import React from 'react';
import { Trans } from 'react-i18next';

import { useBackgroundImageService } from 'hooks/use-background-image-service.hook';

import { Typography } from 'components/typography';

import { TypographyVariants } from 'constants/typography-variants';

import { useStyles } from './styles';

export const OrderDetails = () => {
    const { orderDetailsListWrapper, orderDetailsListItem, text} = useStyles();

    const items = ['svg/checkout/order-details/shipping-icon.svg', 'svg/checkout/order-details/cancel-icon.svg', 'svg/checkout/order-details/medical-advisor-icon.svg'];
    const pageImages = useBackgroundImageService(items);

    return (
        <div className={orderDetailsListWrapper}>
            <div className={orderDetailsListItem}>
                <img src={pageImages[0]} alt='Shipping Icon' />
                <Typography variant={TypographyVariants.h3} className={text}>
                    <Trans i18nKey='checkout-order-details-free-shipping' />
                </Typography>
            </div>
            <div className={orderDetailsListItem}>
                <img src={pageImages[1]} alt='Cancel Icon' />
                <Typography variant={TypographyVariants.h3} className={text}>
                    <Trans i18nKey='checkout-order-details-cancel-anytime' />
                </Typography>
            </div>
            <div className={orderDetailsListItem}>
                <img src={pageImages[2]} alt='Medical Advisor Icon' />
                <Typography variant={TypographyVariants.h3} className={text}>
                    <Trans i18nKey='checkout-order-details-medical-advisor' />
                </Typography>
            </div>
        </div>
    );
};
